var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.999,
    height: 33.262,
    viewBox: "0 0 27.999 33.262",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user01",
    transform: "translate(0.75 0.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M94.682,15.3a7.4,7.4,0,0,0,5.409-2.241,7.4,7.4,0,0,0,2.241-5.409,7.4,7.4,0,0,0-2.241-5.409,7.648,7.648,0,0,0-10.818,0A7.4,7.4,0,0,0,87.032,7.65a7.4,7.4,0,0,0,2.241,5.409A7.4,7.4,0,0,0,94.682,15.3Zm0,0",
    transform: "translate(-81.633)",
    fill: "none",
    stroke: "#ee7404",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M26.434,256.4a18.9,18.9,0,0,0-.257-2.007,15.813,15.813,0,0,0-.494-2.018,9.967,9.967,0,0,0-.829-1.882,7.1,7.1,0,0,0-1.251-1.63,5.515,5.515,0,0,0-1.8-1.129,6.21,6.21,0,0,0-2.294-.415,2.328,2.328,0,0,0-1.243.527c-.373.243-.809.524-1.3.835a7.422,7.422,0,0,1-1.676.738,6.508,6.508,0,0,1-4.1,0,7.4,7.4,0,0,1-1.675-.738c-.482-.308-.918-.589-1.3-.836a2.325,2.325,0,0,0-1.243-.527,6.2,6.2,0,0,0-2.294.416,5.51,5.51,0,0,0-1.8,1.129,7.1,7.1,0,0,0-1.25,1.63,9.986,9.986,0,0,0-.829,1.882,15.849,15.849,0,0,0-.493,2.018A18.828,18.828,0,0,0,.063,256.4c-.042.608-.063,1.238-.063,1.876a5.274,5.274,0,0,0,1.566,3.99A5.639,5.639,0,0,0,5.6,263.736H20.9a5.637,5.637,0,0,0,4.036-1.472,5.272,5.272,0,0,0,1.567-3.99c0-.64-.022-1.271-.064-1.876Zm0,0",
    transform: "translate(0 -231.974)",
    fill: "none",
    stroke: "#ee7404",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.91577f029f354a8dc9bf0cad4900fae7.svg";
export { ForwardRef as ReactComponent };